import React, { useEffect, useState } from 'react'
import { Grid, TextField, FormHelperText, MenuItem } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { Controller } from 'react-hook-form'
import classes from './../../pages/createOrder/index.module.scss'
import JalaliUtils from '@date-io/jalaali'
import env from 'client-sdk/src/enviroments/enviroment'
import RonadIcons from '../iconComponent'
import { isWeekendDay } from '../../utils/Date/dayMethods'
import fillmentTypes from 'client-sdk/src/orders/getFulfillmentTypes'
import shippingDefinitions from 'client-sdk/src/orders/shippingDefinitions'
import handleError from '../../utils/handleError'
import { useCutoffHandler } from '../../utils/hook/useGetCutoffList'
import { FillmentTypesProps } from './types'
import { convertDatePersianToEnglish } from '../../utils/helpers'
import moment from 'moment'

const validateNumber = (value: any) => {
  if (!value) {
    return true
  }
  const pattern = /^[0-9]+$/
  return pattern.test(value)
}

function OrderResendInputs(props: any) {
  moment.locale('en')
  const date = new Date()
  const formattedDate = moment(date).format('YYYY-MM-DD')
  const { form, cod, setDeliveryTime, setLocatedInTehran, setAddressDisabled } =
    props
  const { errors, setValue, getValues, control, watch } = form
  const values = getValues()
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([])
  const [shippingdefinitions, setshippingdefinitions] = useState<any>([])
  const [curierDTOList, setCurierDTOList] = useState<any>([])
  const [dateInDatePiker, setDateInDatePiker] = useState<any>('')
  const [visibleBillAmount, setVisibleBillAmount] = useState(false)
  const [firstCourierId, setFirstCourierId] = useState()
  const [firstFulfillmentTypeId, setFirstFulfillmentTypeId] = useState()

  const fulfillmentTypeId = watch('fulfillmentTypeId')
  const courierId = watch('courierId')
  const deliveryServiceId = watch('deliveryServiceId')
  const deliveryDate = watch('deliveryDate')
  const cutoffId = watch('cutoffId')

  const formattedDateSelected = moment(deliveryDate).format('YYYY-MM-DD')
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected)

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
    editMode: true
  })

  useEffect(() => {
    const fetchFillmentTypes = async () => {
      try {
        const { res, ok } = await fillmentTypes('order')
        if (ok) {
          const found = res.find((item: any) => item.id === fulfillmentTypeId)
          if (found) {
            const filtered = res.filter(
              (item: any) =>
                item.interchangeableGroup === found.interchangeableGroup
            )
            setStateFillmentTypes(filtered)
          }
        }
      } catch (error) {
        handleError(error)
      }
    }
    fetchFillmentTypes()
  }, [fulfillmentTypeId])

  useEffect(() => {
    if (
      values.fulfillmentTypeId &&
      typeof values.fulfillmentTypeId === 'number'
    ) {
      setFirstFulfillmentTypeId(fulfillmentTypeId)
      const fetchShippingDefinitions = async () => {
        try {
          const { res, ok } = await shippingDefinitions(
            values.fulfillmentTypeId
          )
          if (ok) {
            setshippingdefinitions(res.shippingDefinitionList)
          }
        } catch (error) {
          handleError(error)
        }
      }
      fetchShippingDefinitions()
    }
  }, [values.fulfillmentTypeId])

  useEffect(() => {
    const getCourierList = () => {
      if (shippingdefinitions.length === 1) {
        setFirstCourierId(courierId)
        const ress = shippingdefinitions.flatMap(
          (item: any) => item.deliveryServiceDTO
        )
        setValue('deliveryServiceId', ress[0].id)
        return ress[0]
      } else {
        const selectedDefinition = shippingdefinitions.find(
          (item: any) => item.deliveryServiceDTO.id === deliveryServiceId
        )
        return selectedDefinition ? selectedDefinition.deliveryServiceDTO : []
      }
    }
    const courierList = getCourierList()
    setCurierDTOList(courierList.courierDTOList)
  }, [deliveryServiceId, shippingdefinitions])

  useEffect(() => {
    if (curierDTOList) {
      const res = curierDTOList.find((item: any) => item.id === courierId)
      setLocatedInTehran(res?.locatedInTehran ?? false)
      setAddressDisabled(res?.addressDisabled ?? false)
      setVisibleBillAmount(res?.visibleBillAmount ?? false)
    }
  }, [curierDTOList, courierId])

  useEffect(() => {
    if (listCutoff.length > 0) {
      const rse = listCutoff.find((item: any) => item.id === cutoffId)
      setDeliveryTime(rse?.value)
    }
  }, [listCutoff, cutoffId])

  useEffect(() => {
    setValue('origin', env.destinationId)
  }, [])
  useEffect(() => {
    if (firstCourierId && courierId && firstCourierId !== courierId) {
      setValue('cutoffId', '')
    }
  }, [courierId, firstCourierId])

  useEffect(() => {
    if (
      firstFulfillmentTypeId &&
      fulfillmentTypeId &&
      fulfillmentTypeId !== firstFulfillmentTypeId
    ) {
      setValue('cutoffId', '')
      setValue('courierId', '')
    }
  }, [fulfillmentTypeId, firstFulfillmentTypeId])

  return (
    <Grid container item md={8} spacing={2}>
      <Grid item xs={12} sm={6} md={3} lg={3}>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='orderType'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='returnStatus'
              label='تعیین وضعیت'
              rules={{ required: true }}
              as={
                <TextField
                  select
                  fullWidth
                  variant='outlined'
                  error={!values.returnStatus}
                >
                  <MenuItem
                    data-cy='REQUESTED_TO_RESEND'
                    value={'REQUESTED_TO_RESEND'}
                  >
                    ارسال مجدد
                  </MenuItem>
                  <MenuItem
                    data-cy='REQUESTED_TO_RETURN'
                    value={'REQUESTED_TO_RETURN'}
                  >
                    بازگشت به انبار
                  </MenuItem>
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors.orderType && 'نوع سفارش الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={3} lg={3}>
        <div className={classes.item}>
          <div style={{ width: '100%' }}>
            <Controller
              name='trackingCode'
              label='کدپیگیری'
              control={control}
              rules={{
                required: true,
                pattern: /^[A-Za-z\d\-_]+$/,
                minLength: 3
              }}
              as={
                <TextField
                  type='search'
                  variant='outlined'
                  fullWidth
                  id='trackingCode'
                  name='trackingCode'
                  disabled
                  error={!!errors.trackingCode && !!errors.trackingCode}
                  InputProps={{
                    endAdornment: (
                      <RonadIcons
                        name='information'
                        className='text-primary'
                        size={0.8}
                        title='کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید'
                      />
                    )
                  }}
                />
              }
            />
            <FormHelperText error focused>
              {errors?.trackingCode?.type === 'required' &&
                'کدپیگیری الزامی میباشد'}
            </FormHelperText>
            <FormHelperText error focused>
              {errors?.trackingCode?.type === 'minLength' &&
                'کد پیگیری حداقل 3 کاراکتر می باشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3} alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='fulfillmentTypeId'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='fulfillmentTypeId'
              label=' نوع سفارش'
              rules={{
                required: true
              }}
              as={
                <TextField
                  type='search'
                  variant='outlined'
                  select
                  fullWidth
                  InputLabelProps={{
                    shrink: fulfillmentTypeId
                  }}
                  disabled={values.returnStatus !== 'REQUESTED_TO_RESEND'}
                  error={errors.deliveryType && true}
                >
                  {stateFillmentTypes.map((item: FillmentTypesProps) => (
                    <MenuItem key={item.id} data-cy={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors?.deliveryType && 'نوع سفارش  الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item lg alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='deliveryServiceId'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='deliveryServiceId'
              id='deliveryServiceId'
              label='خدمات تحویل'
              // rules={{
              //     required: true,
              // }}
              as={
                <TextField
                  disabled={
                    values.returnStatus !== 'REQUESTED_TO_RESEND' ||
                    fulfillmentTypeId === ''
                  }
                  type='search'
                  variant='outlined'
                  select
                  fullWidth
                  InputLabelProps={{
                    shrink: deliveryServiceId
                  }}
                  error={errors.deliveryServiceId && true}
                >
                  {shippingdefinitions?.map((item: any, index: number) => (
                    <MenuItem
                      key={index}
                      data-cy='COURIER'
                      value={item.deliveryServiceDTO.id}
                    >
                      {item.deliveryServiceDTO.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            {/* <FormHelperText error focused>
                            {errors?.deliveryType &&
                                'نوع سفارش الزامی میباشد'}
                        </FormHelperText> */}
          </div>
        </div>
      </Grid>

      <Grid item lg alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='courierId'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='courierId'
              id='courierId'
              label='* ناوگان حمل'
              rules={{
                required: true
              }}
              as={
                <TextField
                  style={{ width: '100%' }}
                  type='search'
                  variant='outlined'
                  select
                  InputLabelProps={{
                    shrink: courierId
                  }}
                  fullWidth
                  disabled={
                    values.returnStatus !== 'REQUESTED_TO_RESEND' ||
                    fulfillmentTypeId === ''
                  }
                  error={errors.courierId && true}
                >
                  {curierDTOList?.map((item: any) => (
                    <MenuItem key={item.id} data-cy={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors?.courierId && 'ناوگان حمل الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} sm={6} md={3} lg={3}>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='deliveryDatePicker'>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa'>
              <Controller
                rules={{ required: true }}
                name='deliveryDate'
                control={control}
                as={
                  <DatePicker
                    inputVariant='outlined'
                    id='deliveryDate'
                    name='deliveryDate'
                    label='* تاریخ تحویل سفارش'
                    format='jYYYY/jMM/jDD'
                    // minDate={calculateMinDate()}
                    minDate={dateInDatePiker}
                    shouldDisableDate={(d: any) => isWeekendDay(d?._d)}
                    fullWidth
                    disablePast
                    autoOk
                    okLabel='تأیید'
                    cancelLabel='لغو'
                    defaultValue={null}
                    onChange={() => {}}
                    disabled={
                      values.returnStatus !== 'REQUESTED_TO_RESEND' ||
                      fulfillmentTypeId === ''
                    }
                    value={values.deliveryDate || dateInDatePiker}
                    error={errors.hasOwnProperty('deliveryDate')}
                    helperText={
                      errors.deliveryDate && errors.deliveryDate.message
                    }
                  />
                }
              />
              <FormHelperText error focused>
                {errors.deliveryDate && 'تاریخ تحویل سفارش الزامی میباشد'}
              </FormHelperText>
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </Grid>

      <Grid item xs={12} sm={6} md={3} lg>
        <Controller
          rules={{ required: values.returnStatus == 'REQUESTED_TO_RESEND' }}
          style={{ width: '100%' }}
          control={control}
          name='cutoffId'
          id='cutoffId'
          label='* بازه تحویل سفارش'
          as={
            <TextField
              variant='outlined'
              select
              fullWidth
              label='* بازه تحویل سفارش'
              disabled={
                values.deliveryType == '' ||
                courierId === '' ||
                values.returnStatus !== 'REQUESTED_TO_RESEND'
              }
              error={!!errors.cutoffId}
              InputLabelProps={{
                shrink: cutoffId
              }}
            >
              {listCutoff.map((item: any) => (
                <MenuItem
                  disabled={!item.disableCutoff}
                  key={item.id}
                  value={item.id}
                  id={item.id}
                >
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          }
        />
        <FormHelperText error focused>
          {errors?.cutoffId && ' بازه تحویل سفارش الزامی میباشد'}
        </FormHelperText>
      </Grid>

      <Grid item xs={12} sm={4} md={3} lg={3} alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }}>
            <Controller
              name='orderValue'
              label='ارزش سفارش (ریال)'
              control={control}
              rules={{
                required: false,
                validate: validateNumber
              }}
              as={
                <TextField
                  type='search'
                  variant='outlined'
                  fullWidth
                  disabled={
                    values.deliveryType == '' ||
                    values.returnStatus !== 'REQUESTED_TO_RESEND'
                  }
                  id='orderValue'
                  name='orderValue'
                  error={!!errors.orderValue && !!errors.orderValue}
                  InputProps={{
                    endAdornment: (
                      <RonadIcons
                        name='information'
                        className='text-primary'
                        size={0.8}
                        title='مقدار وارد شده به عنوان ارزش سفارش جهت بیمه ارسال اعمال میگردد'
                      />
                    )
                  }}
                />
              }
            />
            <FormHelperText error focused>
              {errors.orderValue?.type === 'required' &&
                'ارزش سفارش الزامی میباشد'}
            </FormHelperText>
            <FormHelperText error focused>
              {errors?.orderValue?.type === 'validate' &&
                'لطفا عدد انگلیسی وارد کنید'}
            </FormHelperText>
          </div>
        </div>
      </Grid>
      {visibleBillAmount && (
        <Grid item xs={12} md={3} lg={3}>
          <div className={classes.item}>
            <div style={{ width: '100%' }}>
              <Controller
                name='cost'
                label='مبلغ فاکتور(ریال)'
                control={control}
                rules={{
                  required: cod,
                  validate: validateNumber
                }}
                as={
                  <TextField
                    type='text'
                    variant='outlined'
                    fullWidth
                    disabled={
                      !cod || values.returnStatus !== 'REQUESTED_TO_RESEND'
                    }
                    id='cost'
                    name='cost'
                    error={!!errors.cost && !!errors.cost}
                    InputProps={{
                      endAdornment: (
                        <RonadIcons
                          name='information'
                          className='text-primary'
                          size={0.8}
                          title='مقدار وارد شده به عنوان مبلغ نهایی از گیرنده سفارش دریافت میگردد'
                        />
                      )
                    }}
                  />
                }
              />
              <FormHelperText error focused>
                {errors?.cost?.type === 'required' &&
                  'مبلغ فاکتور الزامی میباشد'}
              </FormHelperText>
              <FormHelperText error focused>
                {errors?.cost?.type === 'validate' &&
                  'لطفا عدد انگلیسی وارد کنید'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
      )}
    </Grid>
  )
}

export default OrderResendInputs
